<template lang="pug">
  .preorder
    table.table
      tr
        th.row-label
          .label.text-left {{ matrix.labels.row }}
        th.col-label(:colspan="colProp.options.length")
          .label.text-left {{ colProp.label }}
        th.qty-label
          .label.text-left Anzahl
        th.price-label
          .label.text-left Preis
      tr
        th.row-label
          //- .label {{ matrix.labels.row }}
        th.col-label(v-for="col in colProp.options.sort((a, b) => (a.position || 0) - (b.position || 0))")
          .label {{ col.value }}
        th.qty-label
        th.price-label
      tr(v-if="recommandations")
        th.article-sum
          input(type="number" min="0" step="1" v-model="articleSum" onfocus="this.select()")
          | Stck.
        td.text-center(v-for="recommendation in matrix.recommendations")
          .label.percentage(v-if="!articleSum") {{ recommendation.percentage }}%
          .label.value(v-else) {{ recommendation.value }}
        td
        td
      tr(v-for="(row, i) in matrix.rows" :class="{ 'empty': articles && articles.length && row.cartQty <= 0 }")
        th.vertical-label
          .row-label-cell
            //- .colorimage-cell(
            //-   v-if="row.image && row.image.src"
            //-   :style="{ backgroundImage: 'url(' + row.image.src + ')'}"
            //- )
            span.label {{ row.label }}
        td.articles(v-for="col in row.columns")
          PreorderArticle(
            :article="col.article"
            :valid="valid"
            :manageStock="manageStock"
          )
          //- button.button.is-small.is-link(
          //-   :class="{ 'is-active': col.article && col.article.id === activeArticleId, 'is-out-of-stock': manageStock && col.article && !col.article.qty_sum }"
          //-   :disabled="!col.article || (manageStock && !col.article.qty_sum)"
          //-   @click="selectArticle(row, col)"
          //- ) {{ col.label }}
        td.qty.text-center
          span.label {{ row.cartQty }}
        td.price.text-right
          span.label {{ row.cartPrice }}
</template>

<script>
import Matrix from './Matrix';
import PreorderArticle from './PreorderArticle';

export default {
    name: 'Preorder',
    extends: Matrix,
    components: {
        PreorderArticle
    }
};
</script>

<style lang="sass" scoped>
.preorder
  // margin: -2px
table.table
  @apply border-1 w-full
  border-spacing: 0
  border-collapse: separate
  position: relative
  z-index: 1
  .row-label-cell
    display: flex
    align-items: center
    .label
      line-height: 1

    .colorimage-cell
      margin-right: 4px
      padding: 0 !important
      width: 30px
      height: 30px
      background-position: center
      // background-size: cover
      background-repeat: no-repeat

  td, th
    @apply border-1 border-r-0 border-b-0 p-1
    &:first-child
      @apply border-l-0
  tr:first-of-type
    td, th
      @apply border-t-0

  tr.hr td
    padding-top: 0.5rem

  td.has-button
    width: 1px

  .label
    @apply font-medium

  .buttons
    margin: 0 -2px
    .button
      margin: 0 2px

  .vertical-label
    padding-left: 7.5px
    padding-right: calc(1rem - 2px)
    white-space: nowrap
    width: 120px

  .row-label,
  .col-label,
  .qty-label,
  .price-label
    @apply text-center p-2 bg-gray-100
  .articles,
  .qty,
  .price
    background-color: #fff

  th.article-sum
    display: flex
    justify-content: center
    align-items: center
    gap: 10px
</style>
